export const closeLocationMutation = /* GraphQL */ `
mutation CloseLocation($input: closeLocation!) {
	closeLocation(input: $input) {
		id
	}
}
`
